var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 15.5833H15.5833V4.25H4.25V15.5833ZM7.08333 7.08333H12.75V12.75H7.08333V7.08333ZM4.25 29.75H15.5833V18.4167H4.25V29.75ZM7.08333 21.25H12.75V26.9167H7.08333V21.25ZM18.4167 4.25V15.5833H29.75V4.25H18.4167ZM26.9167 12.75H21.25V7.08333H26.9167V12.75ZM18.4308 18.4167H21.2642V21.25H18.4308V18.4167ZM21.2642 21.25H24.0975V24.0833H21.2642V21.25ZM18.4308 24.0833H21.2642V26.9167H18.4308V24.0833ZM24.0975 24.0833H26.9308V26.9167H24.0975V24.0833ZM26.9308 26.9167H29.7642V29.75H26.9308V26.9167ZM21.2642 26.9167H24.0975V29.75H21.2642V26.9167ZM24.0975 18.4167H26.9308V21.25H24.0975V18.4167ZM26.9308 21.25H29.7642V24.0833H26.9308V21.25Z",
    fill: "#213867"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.3356c5b0e596dc0b38677aaf155de001.svg";
export { ForwardRef as ReactComponent };